export default __webpack_public_path__ + "img/banner.3cca837b.jpg";